import _ from 'lodash';
import { marked } from 'marked';
import { useSelector } from 'react-redux';
import { Typography } from 'antd';

import { THEME_MODE } from '../../../data/configs/constants';

const RenderHtmlOrMarkdown = ({ textPayload, ...restProps }) => {
    const themeMode = useSelector((state) => state.pageDetails.themeMode)
    const renderer = new marked.Renderer();
    const originalLinkRenderer = renderer.link;
    renderer.link = (href, title, text) => {
        const html = originalLinkRenderer.call(renderer, href, title, text);
        return html.replace(/^<a /, '<a target="_blank" rel="noopener noreferrer" ');
    };

    return(
        <Typography
            style={{
                width: "100%",
                "overflow": "auto",
                "whiteSpace": "normal",
                "& pre": {
                    backgroundColor: themeMode === THEME_MODE.DARK ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.9)",
                    color: themeMode === THEME_MODE.DARK ? "inherit" : "white",
                    width: "100%",
                    overflow: "auto",
                    padding: "12px",
                    borderRadius: "8px",
                },
                "& ul": {
                    paddingLeft: "24px",
                },
                "& ol": {
                    paddingLeft: "24px",
                },
            }}
            dangerouslySetInnerHTML={{ __html: marked.parse( _.isEmpty(textPayload) ? '' : textPayload, { renderer }) }}
        />
    )
}

export default RenderHtmlOrMarkdown